import React from 'react';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CreditCard, ArrowDownUp, PiggyBank, Receipt } from 'lucide-react';

const Banking = () => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a1e 0%, #1a0a2e 100%)',
      padding: '2rem',
      color: '#fff'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h1 style={{
            fontSize: '3rem',
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '1rem',
            fontWeight: 'bold'
          }}>
            Banking & Budgeting
          </h1>
          <p style={{ color: '#888', fontSize: '1.1rem', maxWidth: '800px', margin: '0 auto' }}>
            Personal banking, budget planning, and expense tracking with AI insights
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '1.5rem',
          marginBottom: '3rem'
        }}>
          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 255, 0.1)',
            border: '1px solid rgba(0, 255, 255, 0.3)'
          }}>
            <CreditCard size={32} style={{ color: '#00ffff', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Account Management</h3>
            <p style={{ color: '#888' }}>Track balances and transactions</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(0, 255, 136, 0.1)',
            border: '1px solid rgba(0, 255, 136, 0.3)'
          }}>
            <PiggyBank size={32} style={{ color: '#00ff88', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Budget Planner</h3>
            <p style={{ color: '#888' }}>Create and manage budgets</p>
          </Card>

          <Card style={{
            padding: '1.5rem',
            background: 'rgba(138, 43, 226, 0.1)',
            border: '1px solid rgba(138, 43, 226, 0.3)'
          }}>
            <Receipt size={32} style={{ color: '#ba55d3', marginBottom: '1rem' }} />
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>Expense Tracking</h3>
            <p style={{ color: '#888' }}>Monitor spending patterns</p>
          </Card>
        </div>

        <Card style={{
          padding: '2rem',
          background: 'rgba(10, 10, 30, 0.8)',
          border: '1px solid rgba(0, 255, 255, 0.2)',
          marginBottom: '2rem'
        }}>
          <h2 style={{ fontSize: '1.5rem', color: '#00ffff', marginBottom: '1.5rem' }}>Banking Widgets</h2>
          <div style={{ color: '#888', lineHeight: '1.8' }}>
            <p>Personal banking and budgeting tools:</p>
            <ul style={{ marginTop: '1rem', paddingLeft: '2rem' }}>
              <li>Account Balance Dashboard</li>
              <li>Transaction History</li>
              <li>Budget Creator & Tracker</li>
              <li>Savings Goals Manager</li>
              <li>Bill Payment Scheduler</li>
              <li>Spending Analytics</li>
            </ul>
          </div>
        </Card>

        <Card style={{
          padding: '2rem',
          background: 'linear-gradient(135deg, rgba(0,255,255,0.1), rgba(0,255,136,0.1))',
          border: '2px solid #00ffff'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <ArrowDownUp size={32} style={{ color: '#00ffff' }} />
            <h2 style={{ fontSize: '1.5rem', color: '#00ffff' }}>Banking AI Advisor</h2>
          </div>
          <p style={{ color: '#ccc', marginBottom: '1.5rem' }}>
            Get smart banking advice from AI financial coaches. Ask about budgeting strategies, 
            saving tips, expense optimization, or any banking question.
          </p>
          <Button style={{
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            color: '#000',
            fontWeight: 'bold',
            padding: '1rem 2rem'
          }}>
            Chat with Banking AI
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Banking;